<template>
    <div>
        <Layout>
            <PageHeader :title="title" :items="items" />
            <section class="ticket_info">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-md-12">
                            <div class="row shadow-lg bg-white p-5 rounded">
                                <div class="col-md-12">
                                    <h4 class="fw-bold m-0 mb-3">Ticket Info</h4>
                                </div>
                               
                                <div class="col-md-12">
                                    <label class="fw-bold">Name:
                                        <span class="fw-normal text-capitalize">{{ticketData.author_name}}</span></label>
                                </div>
                                <!-- Name  -->
                                <div class="col-md-12 mb-3">
                                    <label class="fw-bold">Status:
                                        <span :style="status(ticketData.status)" class="fw-normal text-capitalize px-2 py-1 rounded">{{ticketData.status}}</span></label>
                                </div>
                                <!-- Status  -->
                              

                                <div class="col-md-12 mb-3">
                                    <label class="fw-bold">Comments: </label>
                                    <div class="previous_data border border-grey" v-if="ticketData.comments!=''">
                                        <div class="previous_chat_data border border-grey d-flex mb-2"
                                        v-for="(data, index) in ticketData.comments" :key="index">
                                            <div class="user_img">
                                                <i class="fas fa-user-tie fs-1 me-2"></i>
                                            </div>
                                           <div class="user_date_comment_box">
                                            <div class="user_date_box d-flex justify-content-between">
                                                <span class="fw-bold">{{ data.user.name}}</span>
                                                <p class="m-0">{{ new Date(data.created_at).toLocaleDateString("en-US", options) }}</p>
                                            </div>
                                            <div class="user_name_comment">
                                                <p class="m-0">{{ data.comment}}</p>
                                            </div>
                                           </div>
                                        </div>
                                        <!-- 1  -->
                                    </div>
                                    <div class="d-flex justify-content-center border border-grey mb-2 previous_chat_data" v-else>
                                        No Comment Available
                                      </div>
                                </div>
                                <!-- Previous Data  -->
                                <form @submit.prevent="submitCmnt">
                                    <div class="col-md-12 mb-3" v-if="ticketData.status != 'close'">
                                        <label class="fw-bold">Comment</label>
                                        <textarea class="form-control shadow-none" placeholder="Leave a comment here"
                                            style="height: 100px" v-model.trim="$v.form.comment.$model"></textarea>
                                            <div class="error" v-if="submitted && !$v.form.comment.required">Comment is Required</div>
                                    </div>
                                    <!-- Input field  -->
                                    <div class="col-md-12 text-center" v-if="ticketData.status != 'close'">
                                        <button type="submit" class="btn btn-outline-dark col-5 col-md-4 col-lg-3 col-xl-2">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                                <!-- Button  -->
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    </div>

</template>

<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import { required } from 'vuelidate/lib/validators';
    import ApiClass from "../../api/api";
    import Swal from "sweetalert2";

    export default {
        components: {
            Layout, PageHeader
        },

        data() {
            return {
                title: "View Ticket",
                items: [
                    {
                        text: "Ticket List",
                        href: "/support/ticket-list",
                    },
                    {
                        text: "View Ticket",
                        active: true,
                    },
                ],
                submitted: false,
                form: {
                    comment: "",
                    ticket_id:this.$route.params.slug
                },
               // current_id: this.$route.params.slug,
                ticketData:{},
                options : { year: 'numeric', month: 'long', day: 'numeric',hour: 'numeric',minute: 'numeric',second: 'numeric' }

            }
        },
        validations: {
            form: {
                comment: { required }
            }
        },

        mounted() {
            this.getTicket();
        },

        methods: {

            status(change){
                    if(change == 'open'){
                        return{
                            color:'#256029',
                            backgroundColor:'#c8e6c9'
                        }
                    }
                    else if(change == 'close'){
                        return{
                            color:'#c63737',
                            backgroundColor:'#ffcdd2'
                        }
                    }
                    else if(change == 'inprogress'){
                        return{
                            color:'#805b36',
                            backgroundColor:'#ffd8b2'
                        }
                    }
            },
            async getTicket() {
                var result = await ApiClass.getRequest("admin/ticket/get/"+this.form.ticket_id, true);
                console.log('result', result);
                if(result.data.status_code == 1){
                    this.ticketData = result.data.data;
                    console.log(this.ticketData);
                }
            },
            async submitCmnt(){
                this.submitted = true;
                if (this.$v.form.$invalid){
                     return;
                }
              
                this.submitted = false;
                await ApiClass.postRequest("ticket_comment/create", true, this.form).then((res) => {
                    console.log(res);
                    if (res.data.status_code == 1) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: res.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                    });
                   this.getTicket();
                   this.form.comment ='';
                        
                    }else{
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: res.data.message,
                            showConfirmButton: false,
                            timer: 2000,
                        });
                    }
                })


            }
        }
    }
</script>

<style scoped>
    section.ticket_info {
        padding: 50px 0;
    }

    .previous_data {
        padding: 10px 10px;
        border-radius: 5px;
        height: 200px;
        overflow-y: auto;
    }

    .previous_chat_data {
        padding: 10px 10px;
        border-radius: 5px;
        
    }
    .border-grey{
        border-color: #ced4da !important;
    }
    .user_date_comment_box{
        width: 100%;
    }
</style>